export interface AdPreview {
  prompt: string;
  response: string;
  ad: {
    title: string;
    description: string;
    cta: string;
  };
  placement: 'before' | 'inline' | 'after' | 'recommendation';
}

export interface AgentOutput {
  task: string;
  result: {
    type: 'table' | 'summary' | 'list';
    data: any;
  };
  ad: {
    title: string;
    description: string;
    cta: string;
  };
}

// Mock data for previews
const mockPreviews: Record<string, Record<string, AdPreview>> = {
  "What's the best CRM for startups?": {
    before: {
      prompt: "What's the best CRM for startups?",
      response: "For startups, I recommend considering these top CRM options:\n\n1. HubSpot - Offers a generous free tier and scales well as you grow\n2. Salesforce - Industry standard with powerful features\n3. Pipedrive - Great for sales-focused teams\n4. Freshworks - Affordable with good automation\n5. Zoho CRM - Cost-effective with comprehensive features",
      ad: {
        title: "Supercharge Your Startup's Growth",
        description: "Get 50% off your first year of our enterprise CRM solution. Perfect for scaling startups.",
        cta: "Start Free Trial"
      },
      placement: 'before'
    },
    inline: {
      prompt: "What's the best CRM for startups?",
      response: "For startups, I recommend considering these top CRM options:\n\n1. HubSpot - Offers a generous free tier and scales well as you grow\n\n2. Salesforce - Industry standard with powerful features\n\n3. Pipedrive - Great for sales-focused teams\n\n4. Freshworks - Affordable with good automation\n\n5. Zoho CRM - Cost-effective with comprehensive features",
      ad: {
        title: "Supercharge Your Startup's Growth",
        description: "Get 50% off your first year of our enterprise CRM solution. Perfect for scaling startups.",
        cta: "Start Free Trial"
      },
      placement: 'inline'
    },
    after: {
      prompt: "What's the best CRM for startups?",
      response: "For startups, I recommend considering these top CRM options:\n\n1. HubSpot - Offers a generous free tier and scales well as you grow\n2. Salesforce - Industry standard with powerful features\n3. Pipedrive - Great for sales-focused teams\n4. Freshworks - Affordable with good automation\n5. Zoho CRM - Cost-effective with comprehensive features",
      ad: {
        title: "Supercharge Your Startup's Growth",
        description: "Get 50% off your first year of our enterprise CRM solution. Perfect for scaling startups.",
        cta: "Start Free Trial"
      },
      placement: 'after'
    },
    recommendation: {
      prompt: "What's the best CRM for startups?",
      response: "For startups, I recommend considering these top CRM options:\n\n1. HubSpot - Offers a generous free tier and scales well as you grow\n2. Salesforce - Industry standard with powerful features\n3. Pipedrive - Great for sales-focused teams\n4. Freshworks - Affordable with good automation\n5. Zoho CRM - Cost-effective with comprehensive features",
      ad: {
        title: "Supercharge Your Startup's Growth",
        description: "Get 50% off your first year of our enterprise CRM solution. Perfect for scaling startups.",
        cta: "Start Free Trial"
      },
      placement: 'recommendation'
    }
  },
  "How do I automate onboarding emails?": {
    before: {
      prompt: "How do I automate onboarding emails?",
      response: "Here's a comprehensive guide to automating your onboarding emails:\n\n1. Choose an email automation platform (Mailchimp, SendGrid, etc.)\n2. Create a welcome email sequence\n3. Set up triggers based on user actions\n4. Personalize content using merge tags\n5. Test and optimize your sequence",
      ad: {
        title: "Automate Your Customer Onboarding",
        description: "Our AI-powered platform helps you create and manage personalized onboarding sequences. Start free today!",
        cta: "Try for Free"
      },
      placement: 'before'
    },
    inline: {
      prompt: "How do I automate onboarding emails?",
      response: "Here's a comprehensive guide to automating your onboarding emails:\n\n1. Choose an email automation platform (Mailchimp, SendGrid, etc.)\n\n2. Create a welcome email sequence\n\n3. Set up triggers based on user actions\n\n4. Personalize content using merge tags\n\n5. Test and optimize your sequence",
      ad: {
        title: "Automate Your Customer Onboarding",
        description: "Our AI-powered platform helps you create and manage personalized onboarding sequences. Start free today!",
        cta: "Try for Free"
      },
      placement: 'inline'
    },
    after: {
      prompt: "How do I automate onboarding emails?",
      response: "Here's a comprehensive guide to automating your onboarding emails:\n\n1. Choose an email automation platform (Mailchimp, SendGrid, etc.)\n2. Create a welcome email sequence\n3. Set up triggers based on user actions\n4. Personalize content using merge tags\n5. Test and optimize your sequence",
      ad: {
        title: "Automate Your Customer Onboarding",
        description: "Our AI-powered platform helps you create and manage personalized onboarding sequences. Start free today!",
        cta: "Try for Free"
      },
      placement: 'after'
    },
    recommendation: {
      prompt: "How do I automate onboarding emails?",
      response: "Here's a comprehensive guide to automating your onboarding emails:\n\n1. Choose an email automation platform (Mailchimp, SendGrid, etc.)\n2. Create a welcome email sequence\n3. Set up triggers based on user actions\n4. Personalize content using merge tags\n5. Test and optimize your sequence",
      ad: {
        title: "Automate Your Customer Onboarding",
        description: "Our AI-powered platform helps you create and manage personalized onboarding sequences. Start free today!",
        cta: "Try for Free"
      },
      placement: 'recommendation'
    }
  },
  "Affordable alternatives to Intercom?": {
    before: {
      prompt: "Affordable alternatives to Intercom?",
      response: "Here are some cost-effective alternatives to Intercom:\n\n1. Crisp - Great for small teams\n2. Drift - Focus on sales conversations\n3. Tawk.to - Completely free for basic use\n4. Freshchat - Good for customer support\n5. Zendesk Chat - Enterprise-grade features",
      ad: {
        title: "Powerful Chat Solution for Small Teams",
        description: "Get all the features you need at a fraction of the cost. Perfect for growing businesses.",
        cta: "View Pricing"
      },
      placement: 'before'
    },
    inline: {
      prompt: "Affordable alternatives to Intercom?",
      response: "Here are some cost-effective alternatives to Intercom:\n\n1. Crisp - Great for small teams\n\n2. Drift - Focus on sales conversations\n\n3. Tawk.to - Completely free for basic use\n\n4. Freshchat - Good for customer support\n\n5. Zendesk Chat - Enterprise-grade features",
      ad: {
        title: "Powerful Chat Solution for Small Teams",
        description: "Get all the features you need at a fraction of the cost. Perfect for growing businesses.",
        cta: "View Pricing"
      },
      placement: 'inline'
    },
    after: {
      prompt: "Affordable alternatives to Intercom?",
      response: "Here are some cost-effective alternatives to Intercom:\n\n1. Crisp - Great for small teams\n2. Drift - Focus on sales conversations\n3. Tawk.to - Completely free for basic use\n4. Freshchat - Good for customer support\n5. Zendesk Chat - Enterprise-grade features",
      ad: {
        title: "Powerful Chat Solution for Small Teams",
        description: "Get all the features you need at a fraction of the cost. Perfect for growing businesses.",
        cta: "View Pricing"
      },
      placement: 'after'
    },
    recommendation: {
      prompt: "Affordable alternatives to Intercom?",
      response: "Here are some cost-effective alternatives to Intercom:\n\n1. Crisp - Great for small teams\n2. Drift - Focus on sales conversations\n3. Tawk.to - Completely free for basic use\n4. Freshchat - Good for customer support\n5. Zendesk Chat - Enterprise-grade features",
      ad: {
        title: "Powerful Chat Solution for Small Teams",
        description: "Get all the features you need at a fraction of the cost. Perfect for growing businesses.",
        cta: "View Pricing"
      },
      placement: 'recommendation'
    }
  },
  "Best tools for customer support?": {
    before: {
      prompt: "Best tools for customer support?",
      response: "Here are the top customer support tools:\n\n1. Zendesk - Comprehensive support suite\n2. Freshdesk - Great for small teams\n3. Intercom - Excellent for real-time chat\n4. Help Scout - Email-focused support\n5. Front - Unified inbox solution",
      ad: {
        title: "Transform Your Customer Support",
        description: "Our AI-powered support platform helps you deliver exceptional customer service. Start your free trial today!",
        cta: "Start Free Trial"
      },
      placement: 'before'
    },
    inline: {
      prompt: "Best tools for customer support?",
      response: "Here are the top customer support tools:\n\n1. Zendesk - Comprehensive support suite\n\n2. Freshdesk - Great for small teams\n\n3. Intercom - Excellent for real-time chat\n\n4. Help Scout - Email-focused support\n\n5. Front - Unified inbox solution",
      ad: {
        title: "Transform Your Customer Support",
        description: "Our AI-powered support platform helps you deliver exceptional customer service. Start your free trial today!",
        cta: "Start Free Trial"
      },
      placement: 'inline'
    },
    after: {
      prompt: "Best tools for customer support?",
      response: "Here are the top customer support tools:\n\n1. Zendesk - Comprehensive support suite\n2. Freshdesk - Great for small teams\n3. Intercom - Excellent for real-time chat\n4. Help Scout - Email-focused support\n5. Front - Unified inbox solution",
      ad: {
        title: "Transform Your Customer Support",
        description: "Our AI-powered support platform helps you deliver exceptional customer service. Start your free trial today!",
        cta: "Start Free Trial"
      },
      placement: 'after'
    },
    recommendation: {
      prompt: "Best tools for customer support?",
      response: "Here are the top customer support tools:\n\n1. Zendesk - Comprehensive support suite\n2. Freshdesk - Great for small teams\n3. Intercom - Excellent for real-time chat\n4. Help Scout - Email-focused support\n5. Front - Unified inbox solution",
      ad: {
        title: "Transform Your Customer Support",
        description: "Our AI-powered support platform helps you deliver exceptional customer service. Start your free trial today!",
        cta: "Start Free Trial"
      },
      placement: 'recommendation'
    }
  },
  "How to improve customer retention?": {
    before: {
      prompt: "How to improve customer retention?",
      response: "Here are proven strategies to improve customer retention:\n\n1. Implement a loyalty program\n2. Provide exceptional customer service\n3. Regular check-ins and follow-ups\n4. Offer personalized experiences\n5. Collect and act on feedback",
      ad: {
        title: "Boost Your Customer Retention",
        description: "Our retention platform helps you keep customers engaged and loyal. Get started with our free plan!",
        cta: "Get Started"
      },
      placement: 'before'
    },
    inline: {
      prompt: "How to improve customer retention?",
      response: "Here are proven strategies to improve customer retention:\n\n1. Implement a loyalty program\n\n2. Provide exceptional customer service\n\n3. Regular check-ins and follow-ups\n\n4. Offer personalized experiences\n\n5. Collect and act on feedback",
      ad: {
        title: "Boost Your Customer Retention",
        description: "Our retention platform helps you keep customers engaged and loyal. Get started with our free plan!",
        cta: "Get Started"
      },
      placement: 'inline'
    },
    after: {
      prompt: "How to improve customer retention?",
      response: "Here are proven strategies to improve customer retention:\n\n1. Implement a loyalty program\n2. Provide exceptional customer service\n3. Regular check-ins and follow-ups\n4. Offer personalized experiences\n5. Collect and act on feedback",
      ad: {
        title: "Boost Your Customer Retention",
        description: "Our retention platform helps you keep customers engaged and loyal. Get started with our free plan!",
        cta: "Get Started"
      },
      placement: 'after'
    },
    recommendation: {
      prompt: "How to improve customer retention?",
      response: "Here are proven strategies to improve customer retention:\n\n1. Implement a loyalty program\n2. Provide exceptional customer service\n3. Regular check-ins and follow-ups\n4. Offer personalized experiences\n5. Collect and act on feedback",
      ad: {
        title: "Boost Your Customer Retention",
        description: "Our retention platform helps you keep customers engaged and loyal. Get started with our free plan!",
        cta: "Get Started"
      },
      placement: 'recommendation'
    }
  }
};

// Mock data for agent outputs
const mockAgentOutputs: Record<string, AgentOutput> = {
  revenue_analysis: {
    task: 'Show top 10 users by revenue',
    result: {
      type: 'table',
      data: [
        { User: 'Enterprise Corp', Revenue: '$125,000', Growth: '+15%' },
        { User: 'TechStart Inc', Revenue: '$98,500', Growth: '+22%' },
        { User: 'Global Solutions', Revenue: '$87,200', Growth: '+8%' },
        { User: 'Innovate Labs', Revenue: '$76,800', Growth: '+12%' },
        { User: 'Digital Dynamics', Revenue: '$65,400', Growth: '+18%' },
        { User: 'Future Systems', Revenue: '$54,900', Growth: '+5%' },
        { User: 'Smart Solutions', Revenue: '$45,600', Growth: '+9%' },
        { User: 'Cloud Nine', Revenue: '$38,200', Growth: '+14%' },
        { User: 'Data Masters', Revenue: '$32,800', Growth: '+7%' },
        { User: 'AI Innovators', Revenue: '$28,500', Growth: '+11%' }
      ]
    },
    ad: {
      title: 'Want to Predict Future Revenue?',
      description: 'Our AI-powered forecasting tool can help you predict revenue trends and identify growth opportunities.',
      cta: 'Try Revenue Predictor'
    }
  },
  feedback_summary: {
    task: 'Summarize recent feedback',
    result: {
      type: 'summary',
      data: `Based on the analysis of 250+ customer feedback entries from the last 30 days:

Key Positive Themes:
• Improved user interface (45% of feedback)
• Faster response times (38% of feedback)
• Better customer support (32% of feedback)

Areas for Improvement:
• Mobile app performance (28% of feedback)
• Documentation clarity (22% of feedback)
• Feature request: API integration (18% of feedback)

Overall Satisfaction: 4.2/5 (up from 3.9/5 last month)`
    },
    ad: {
      title: 'Turn Feedback into Action',
      description: 'Our AI-powered feedback analysis tool helps you understand customer sentiment and prioritize improvements.',
      cta: 'Start Free Analysis'
    }
  },
  onboarding_analysis: {
    task: 'Rank onboarding flows by completion',
    result: {
      type: 'list',
      data: [
        'Basic Setup Flow: 92% completion rate',
        'Advanced Configuration: 78% completion rate',
        'Team Invitation: 85% completion rate',
        'Integration Setup: 65% completion rate',
        'Custom Workflow: 58% completion rate'
      ]
    },
    ad: {
      title: 'Optimize Your Onboarding',
      description: 'Our onboarding optimization platform helps you increase completion rates and reduce drop-offs.',
      cta: 'Get Optimization Tips'
    }
  },
  churn_prediction: {
    task: 'Predict potential churn',
    result: {
      type: 'table',
      data: [
        { Customer: 'TechCorp', Risk: 'High', 'Last Activity': '15 days ago', Value: '$45,000' },
        { Customer: 'DataFlow', Risk: 'Medium', 'Last Activity': '8 days ago', Value: '$32,000' },
        { Customer: 'CloudNine', Risk: 'High', 'Last Activity': '20 days ago', Value: '$28,500' },
        { Customer: 'SmartSys', Risk: 'Low', 'Last Activity': '2 days ago', Value: '$52,000' },
        { Customer: 'FutureTech', Risk: 'Medium', 'Last Activity': '12 days ago', Value: '$38,000' }
      ]
    },
    ad: {
      title: 'Prevent Customer Churn',
      description: 'Our AI-powered churn prevention tool helps you identify at-risk customers and take proactive measures.',
      cta: 'Start Free Trial'
    }
  },
  feature_usage: {
    task: 'Analyze feature adoption',
    result: {
      type: 'summary',
      data: `Feature Adoption Analysis (Last 30 Days):

Most Used Features:
1. Dashboard Analytics (85% of users)
2. Report Generation (78% of users)
3. Data Export (72% of users)
4. Team Collaboration (65% of users)
5. Custom Integrations (58% of users)

Growth Trends:
• Dashboard Analytics: +12% adoption
• Report Generation: +8% adoption
• Data Export: +15% adoption
• Team Collaboration: +5% adoption
• Custom Integrations: +10% adoption`
    },
    ad: {
      title: 'Boost Feature Adoption',
      description: 'Our feature adoption platform helps you increase user engagement and drive feature usage.',
      cta: 'Learn More'
    }
  }
};

class PlaygroundApi {
  async getPreview(prompt: string, placement: string): Promise<AdPreview> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    const preview = mockPreviews[prompt]?.[placement];
    if (!preview) {
      throw new Error('Preview not found');
    }
    
    return preview;
  }

  async getAgentOutput(task: string): Promise<AgentOutput> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    const output = mockAgentOutputs[task];
    if (!output) {
      throw new Error('Agent output not found');
    }
    
    return output;
  }
}

export const playgroundApi = new PlaygroundApi(); 